import React from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
import { Table } from 'antd'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

export const ContentfulRenderTable = (node, renderNodeOptions) => {
  const rows = node.content || []

  if (!rows.length) return null

  const isHeaderRow = rows[0].content.some((cell) => cell.nodeType === BLOCKS.TABLE_HEADER_CELL)

  const columns = rows[0].content.map((cell, i) => ({
    title: documentToReactComponents(cell, renderNodeOptions),
    dataIndex: `col${i}`,
    key: `col${i}`,
    onHeaderCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  }))

  const dataSource = rows.slice(isHeaderRow ? 1 : 0).map((row, rowIndex) => {
    const rowData = {}
    row.content.forEach((cell, cellIndex) => {
      rowData[`col${cellIndex}`] = documentToReactComponents(cell, renderNodeOptions)
    })
    return {
      key: rowIndex,
      ...rowData,
    }
  })

  return <Table columns={columns} dataSource={dataSource} pagination={false} bordered />
}
